import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../routes'
import { settings } from '../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../AuthenticatedUserContext'
import { FormLoader } from '../../components/Loader/FormLoader'
import SettingsContent from '../../components/SettingsContent'


const Settings = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Sidebar.Links.Settings' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={settings.image}
           description={intl.formatMessage({ id: 'Sidebar.Links.Settings' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, getSettings }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ?
                <Layout content={<SettingsContent getSettings={getSettings}/>}/> :
                (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default Settings

